import React, { useEffect } from "react";
import {
  createDraftSafeSelector,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { SHOP_DATA } from "pages/shop/Shop";
import {
  addCollectionAndDocuments,
  getCategoriesAndDocuments,
} from "services/firebase";
import { categoriesArray } from "./categoriesThunk";

const initialState = {
  categories: [],
  isLoading: false,
  error: null,
};

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    // getCatsAndDocsFromDb: (state, action) => {
    //     // const categoriesAndDocuments = async() => {
    //     //     const categories = await getCategoriesAndDocuments();
    //     //     state.categories = categories
    //     // }
    //     // categoriesAndDocuments()
    // },
    // getCategories: (state, action) => {
    //     state.categories = action.payload
    // },
    // fetchCategoriesStart: (state, action) => {
    //     state.isLoading = true
    // },
    // fetchCategoriesSuccess: (state, action) => {
    //     state.isLoading = false
    //     state.categories = action.payload
    // },
    // fetchCategoriesFailed: (state, action) => {
    //     state.isLoading = false
    //     state.error = action.payload
    // }
  },
  extraReducers: (builder) => {
    builder.addCase(categoriesArray.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(categoriesArray.fulfilled, (state, action) => {
      state.isLoading = false;
      state.categories = action.payload?.reverse();
    });
    builder.addCase(categoriesArray.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

const { reducer, actions } = categoriesSlice;
export const {
  getCategories,
  fetchCategoriesStart,
  fetchCategoriesSuccess,
  fetchCategoriesFailed,
} = actions;
export default reducer;

const selectCategory = (state) => state.categories;

export const selectCategories = createSelector(
  [selectCategory],
  (categories) => categories.categories
);

export const selectLoading = createSelector(
  [selectCategory],
  (loading) => loading.isLoading
);

export const selectError = createSelector(
  [selectCategory],
  (error) => error.error
);

export const selectCategoriesMap = createSelector(
  [selectCategories],
  (categoriesMap) => {
    return categoriesMap.reduce((acc, category) => {
      const { title, items } = category;
      acc[title.toLowerCase()] = items;
      return acc;
    }, {});
  }
);
